import { CostosPlataformaService } from "../../generated/grpc/plataforma_costos_pb";
import { ServiceDeleteBase } from "../base/ServiceDeleteBase";
import { grpcCall, grpcClient } from "../grpc/grpcCall";
import { CostoAspersionListService } from "./CostoAspersionListService";

/** Baja de categorías de PROTEC; la saca del listado en memoria. */
export class CostoAspersionDeleteService extends ServiceDeleteBase {
  static readonly instance = new CostoAspersionDeleteService();
  private constructor() { super(); }

  protected readonly cache = CostoAspersionListService.instance;

  /** gRPC-Web (`EliminarAspersion`): baja lógica de la categoría y sus cultivos; `NotFoundError` si no existe. */
  protected async sendDelete(id: string): Promise<void> {
    await grpcCall(() => grpcClient(CostosPlataformaService).eliminarAspersion({ id }));
  }
}
